import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../css/Login.css";

const EyeIcon = ({ open }) => (
  open ? (
    // Eye Open Icon (simple SVG)
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  ) : (
    // Eye Closed Icon (simple SVG)
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.05 10.05 0 0 1 12 19c-7 0-11-7-11-7a17.91 17.91 0 0 1 5.14-6.63"></path>
      <path d="M1 1l22 22"></path>
      <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24"></path>
      <path d="M14.12 14.12L12 12"></path>
      <path d="M14.12 14.12L19.86 19.86"></path>
    </svg>
  )
);

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const adminEmail = "admin2025@gmail.com";
  const adminPassword = "Admin2025";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (email === adminEmail && password === adminPassword) {
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }
      login(() => navigate("/admin"));
    } else {
      setError("Invalid email or password");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-left">
          <h2>Welcome</h2>
          <p>
            Take full control of your application with a dynamic and intuitive admin panel—built to empower you with seamless management, real-time insights, and total efficiency.
          </p>
        </div>
        <div className="login-right">
          <h3>Admin Login</h3>
          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="text"
              placeholder="admin@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%" }}
            />

            <label>Password</label>
            <div style={{ position: "relative", width: "100%" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: "100%", paddingRight: "40px" }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#007bff",
                  padding: 0,
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                }}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <EyeIcon open={showPassword} />
              </button>
            </div>

            <div style={{ margin: "10px 0" }}>
              <label>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />{" "}
                Remember Me
              </label>
            </div>

            <button type="submit">Log in</button>

            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
